import { NgClass } from '@angular/common';
import { Component, ElementRef, inject } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MssFieldBaseFieldTypeComponent } from '../mss-field-base.component';

@Component({
  templateUrl: 'buttons.component.html',
  styleUrls: ['buttons.component.scss'],
  imports: [NgClass, NgbTooltipModule],
})
export class ButtonsFieldTypeComponent extends MssFieldBaseFieldTypeComponent {
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

  public get numColumns(): number {
    return this.props.numColumns ?? 3;
  }

  public handleButtonClick(button) {
    if (typeof button.onClick === 'function') {
      button.onClick(this.field);
    }

    if (typeof button.eventName === 'string') {
      const event = new Event(button.eventName, { bubbles: true, composed: true });
      this.el.nativeElement.dispatchEvent(event);
    }
  }

  public handleButtonTooltip(button) {
    if (typeof button.helpText === 'function') {
      return button.helpText(this.field);
    }

    return button.helpText;
  }

  public handleButtonDisabled(button) {
    if (typeof button.disabled === 'function') {
      return button.disabled(this.field);
    }

    return button.disabled;
  }
}
